import { render, staticRenderFns } from "./ConfrimationModal.vue?vue&type=template&id=0ff53071"
import script from "./ConfrimationModal.vue?vue&type=script&lang=js"
export * from "./ConfrimationModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports